import { render, staticRenderFns } from "./OrderHistoryView.vue?vue&type=template&id=24c49f50&"
import script from "./OrderHistoryView.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports